<template>

	<div :class="{modal:true,'vis-overflow':overflowVisible,'initial-load':initialLoad,transparent:transparent}">

		<div class="modal-wrap">

			<div class="modal-inner">

				<h2 class="modal-title">{{ title }}<a href="#" class="close" @click="close( false, false )">X</a></h2>

				<div class="modal-inner-scroll" ref="tfModalScroll">

					<div ref="tfModalScrollWrap">

						<p class="tool-tip" v-if="toolTipText!==''&&showSearchToolTip">{{toolTipPreText}} <Tip position="fromRight" :extensive="true"><span v-html="toolTipText"></span></Tip></p>

						<p v-if="description&&!showSearchToolTip" class="opener"><span v-html="description" /><br><span class="hide" @click="hideTip">Hide Tip</span></p>

						<form class="form" @submit.prevent="submit">

							<div>

								<div
									v-for="(search, searchIndex) in searched" 
									:key="'search-'+searchIndex"
									:class="{'search-line':true,multi:searched.length>1}"
								>

									<div
										v-for="(searchGroup, groupIndex) in searchInputs" 
										:key="'group-'+groupIndex"
									>

										<h3 
											v-if="searchGroup.label" 
											v-html="searchGroup.label" 
											:class="{'group-title':true,open:open[searchIndex] && open[searchIndex][searchGroup.groupName]}"
											@click="toggleGroup(searchIndex,searchGroup.groupName)"
										/>

										<span
											v-if="!searchGroup.label||(open[searchIndex] && open[searchIndex][searchGroup.groupName])"
										>

											<div v-if="hiddenFieldsDropdown(searchIndex,groupIndex)" :class="{ 'fields-dropdown': true, 'not-first': searchIndex > 0 }">
												<v-select 
													:placeholder="totalVisibleFieldsInGroup(searchIndex)>0?'Add another field':'Add a field'"
													v-model="addField[searchIndex]" 
													:options="hiddenFieldsDropdown(searchIndex,groupIndex)"
													:clearable="true"
													class="no-margin dark-border"
												/>
											</div>

											<span
												v-for="(searchInput, searchInputIndex) in searchGroup.filters" 
												:key="'filter-'+searchInputIndex"
											>

												<span
													v-for="(instanceName, instanceIndex) in allInputInstances[searchIndex][searchInput.var]" 
													:key="'instance-'+instanceIndex" 
												>

													<span 
														v-if="showField(searchIndex,searchInput.var)"
														:class="{'input-wrap': true, dates: searchInput.type==='date-range', number: searchInput.type==='number', button: searchInput.type==='button', switcher: (searchInput.type.toLowerCase()==='switcher'||searchInput.type.toLowerCase()==='toggle'),'last-added':(!!lastAdded[searchIndex]&&lastAdded[searchIndex]===instanceName)}"
													>

														<label 
															v-if="searchInput.showLabel || ( searchInput.showLabelWhenFilled && searched[searchIndex] && searched[searchIndex][instanceName] && ( (  Array.isArray(searched[searchIndex][instanceName]) && searched[searchIndex][instanceName].length > 0 ) || (  Array.isArray(searched[searchIndex][instanceName]) === false && searched[searchIndex][instanceName] !== '' && searched[searchIndex][searchInput.var] !== null ) ) )"
														>{{labelText(searchInput)}} <Tip v-if="searchInput.tip">{{searchInput.tip}}</Tip> <span v-if="searchInput.duplicate&&hiddenByDefaultCompd.length===0" class="duplicate" :title="'Add another ' + labelText(searchInput) + ' filter'" v-html="'+'" @click="duplicate(searchInput,searchIndex)" /> <span v-if="instanceIndex>0||(allInputInstances[searchIndex][searchInput.var].length===1&&hiddenByDefaultCompd.indexOf(searchInput.var)>=0)" class="delete" :title="'Delete ' + labelText(searchInput) + ' filter'" v-html="'x'" @click="deleteField(searchInput,searchIndex,instanceIndex,instanceName)" /></label>

														<div class="input-text-wrap" v-if="['text','number'].indexOf(searchInput.type)>=0"><span 
															:class="{comparison: true,multi:searchInput.comparisons.length>1}" 
															v-if="searchInput.comparisons.length>0" 
															v-html="getComparisonLabel ( searchIndex, instanceName )" 
															@click="changeComparison ( searchIndex, instanceName )"
														/><input 
															:type="searchInput.type" 
															:placeholder="searchInput.placeholder" 
															v-model="searched[searchIndex][instanceName]" 
															@keypress.enter="searchTable" 
														/></div>

														<span v-if="searchInput.type==='number-from-to'" class="number-from-to">

															<input 
																type="number" 
																:placeholder="searchInput.placeholder.from?searchInput.placeholder.from:''" 
																v-model="searched[searchIndex][instanceName].from" 
																:min="(searchInput.control&&searchInput.control.from&&typeof searchInput.control.from.min!=='undefined')?typeof searchInput.control.from.min:''"
																:max="(searchInput.control&&searchInput.control.from&&typeof searchInput.control.from.max!=='undefined')?typeof searchInput.control.from.max:''"
																@keypress.enter="searchTable"
																@change="filterChanged"
															>

															->

															<input 
																type="number" 
																:placeholder="searchInput.placeholder.to?searchInput.placeholder.to:''" 
																v-model="searched[searchIndex][instanceName].to" 
																:min="(searchInput.control&&searchInput.control.to&&typeof searchInput.control.to.min!=='undefined')?typeof searchInput.control.to.min:''"
																:max="(searchInput.control&&searchInput.control.to&&typeof searchInput.control.to.max!=='undefined')?typeof searchInput.control.to.max:''"
																@keypress.enter="searchTable"
																@change="filterChanged"
															>

														</span>

														<span 
															class="large-button"
															@click="$emit(searchInput.click,searchInput.val)"
															v-html="searchInput.label"
															v-if="searchInput.type==='button'"
														/>

														<span 
															class="large-button"
															@click="$emit(searchInput.click,searchInput.val)"
															v-html="searchInput.label"
															v-if="searchInput.type==='button'"
														/>

														<Switcher 
															:switcherLabel="searchInput.label" 
															:switcherLabel2="searchInput.label2" 
															sameColour="1" 
															v-model="searched[searchIndex][instanceName]" 
															v-if="searchInput.type.toLowerCase()==='switcher'||searchInput.type.toLowerCase()==='toggle'"
														/>

														<v-select 
															:placeholder="searchInput.placeholder"
															v-model="searched[searchIndex][instanceName]" 
															:options="searchInput.items" 
															:reduce="option => option.value" 
															v-if="searchInput.type==='select'&&searchInput.items" 
															:multiple="searchInput.multi ? true : false"
															:clearable="typeof searchInput.clearable !== 'undefined' ? searchInput.clearable : true"
															@change="filterChanged"
														></v-select>

														<v-select 
															:placeholder="searchInput.placeholder"
															v-model="searched[searchIndex][instanceName]" 
															:options="typeof searchInput.options==='string'?selectOptions[searchInput.options]:searchInput.options" 
															:reduce="option => option._id" 
															v-if="searchInput.type==='select'&&searchInput.options" 
															:multiple="searchInput.multi ? true : false"
															:clearable="typeof searchInput.clearable !== 'undefined' ? searchInput.clearable : true"
															@change="filterChanged"
														></v-select>

														<DateFilter
															@change="changeDate(instanceName,searchIndex,$event)" 
															v-if="searchInput.type==='date-range'"
															:fixed="true"
															class="table-filter"
														/>

													</span>

												</span>

											</span>

										</span>

									</div>

									<font-awesome-icon 
										icon="circle-minus" 
										:style="{ color: '#394559' }" 
										@click="removeSearchLine(searchIndex)"
										class="remove"
										v-if="searched.length>1"
									/>

								</div>

							</div>

							<span @click="addSearch" class="add-search" v-if="maxLines===0||maxLines>searched.length">
								<font-awesome-icon 
									icon="circle-plus" 
									:style="{ color: '#394559' }" 
								/>
								<span>{{addAnotherLabel}}</span>
							</span>

							<div class="order-by" v-if="hasOrderBy">

								<h4 class="main-title">Order By</h4>

								<div
									v-for="(orderByOption, orderByIndex) in orderBySelected" 
									:key="'order-by-'+orderByIndex"
									:class="{'order-by-line': true, multi:orderBySelected.length>1 }"
								>

									<font-awesome-icon 
										icon="circle-minus" 
										:style="{ color: '#394559' }" 
										class="remove"
										@click="removeOrderByLine(orderByIndex)"
									/>

									<v-select 
										:placeholder="'Order by'"
										:options="orderByList" 
										v-model="orderByOption.field"
										:reduce="option => option._id" 
										:clearable="false"
									></v-select>

									<v-select 
										:placeholder="'Direction'"
										:options="[{_id:1,label:'Ascending'},{_id:-1,label:'Descending'}]" 
										v-model="orderByOption.direction"
										:reduce="option => option._id" 
										:clearable="false"
										class="direction"
									></v-select>

								</div>

								<span @click="addOrderBy" class="add-search" v-if="orderBySelected.length<orderByMax||orderByMax===0">
									<font-awesome-icon 
										icon="circle-plus" 
										:style="{ color: '#394559' }" 
									/>
									<span v-html="orderBySelected.length>1?'Add another order by':'Add order by'" />
								</span>

							</div>

						</form>

						<TableFilterQuery 
							:searchQuery="searchQuery.query" 
							:orderBySelected="orderBySelected" 
							:searchSetup="searchSetup" 
							:hasOrderBy="hasOrderBy"
							:showAtBottom="true"
						/>

						<div class="footer">

							<span class="large-button search" @click="close( false, true )">Search</span>

							<span class="large-button" @click="close( false, true )">Search</span>

							<span class="large-button clear" @click="clearAll" v-if="showClearAll">Clear All</span>

							<span class="large-button save" @click="saveFilter" v-if="showSaveFilterCompd" v-html="filterId?'Update Filter':'Save Filter'" />

							<div class="filter-name-wrap" v-if="showSaveFilterCompd"><FormInput :noMarginBottom="true" type="text" :inline="true" v-model="filter.name" placeholder="Filter Name" :required="false" /></div>

							<div class="projects" v-if="showSaveFilterCompd&&projectListLoaded&&filter.name!==''">

								<h3>Assign To Projects</h3>

								<FormInput 
									type="checkbox" 
									v-model="filter.allProjects" 
									name="allProjects"
									id="allProjects"
									:noMarginBottom="true"
									label="Assign To All Projects (current and future)"
								/>

								<br />

								<h4 v-if="!filter.allProjects">Assign To Individual Projects</h4>
								<p>The filter will still be accessible in all projects but will be hidden with the option to toggle.</p>

								<FormInput 
									type="checkbox" 
									v-model="filter.projects" 
									:items="projects"
									v-if="!filter.allProjects"
									:noMarginBottom="true"
								/>

							</div>

						</div>

					</div>

				</div>

			</div>

		</div>

	</div>

</template>

<script>
import { ref, computed, watch, onMounted, getCurrentInstance } from 'vue';
import { TokenService } from './../services/storage.service';
import general from '../utils/general';
import DateFilter from './Data/DateFilter.vue';
import Switcher from './Switcher.vue';
import TableFilterQuery from './TableFilterQuery.vue';
import Tip from './Tip.vue';
import FormInput from './Form/Input.vue';

export default {
	name: 'TableFilter',
	components: { DateFilter, Switcher, Tip, TableFilterQuery, FormInput },
	props: {
		filters: {
			type: Array
		},
		outerPad: {
			type: Boolean,
			default: false
		},
		searchSetup: {
			type: Object,
				default: () => { return {}; }
		},
		groupSetup: {
			type: Object,
				default: () => { return {}; }
		},
		comparisonLabels: {
			type: Object,
				default: () => { return {}; }
		},
		selectOptions: {
			type: Object,
				default: () => { return {}; }
		},
		vars: {
			type: Array,
				default: () => { return []; }
		},
		name: {
			type: String,
			default: ''
		},
		title: {
			type: String,
			default: 'Search'
		},
		description: {
			type: String,
			default: ''
		},
		toolTipPreText: {
			type: String,
			default: ''
		},
		toolTipText: {
			type: String,
			default: ''
		},
		addAnotherLabel: {
			type: String,
			default: 'Add another filter group'
		},
		values: {
			type: Object,
				default: () => { return {} }
		},
		maxLines: {
			type: Number,
			default: 0
		},
		orderByList: {
			type: Array,
				default: () => { return [] }
		},
		orderByDefault: {
			type: String,
				default: null
		},
		orderByDefaultDirection: {
			type: String,
				default: null
		},
		orderByMax: {
			type: Number,
			default: 0
		},
		initialLoad: {
			type: Boolean,
			default: false
		},
		hiddenByDefault: {
			type: [Array,String],
				default: () => []
		},
		showSaveFilter: {
			type: Boolean,
			default: false
		},
		meta: {
			type: Object,
			default: () => {}
		}
	},
	setup(props, { emit }) {
		const vm = getCurrentInstance().proxy;
		const store = vm.$store;

		const tfModalScroll = ref(null);
		const tfModalScrollWrap = ref(null);

		const searched = ref([]);
		const overflowVisible = ref(false);
		const open = ref({});
		const comparisonSelected = ref({});
		const inputInstances = ref({});
		const orderBySelected = ref([]);
		const hidden = ref([]);
		const addField = ref({});
		const lastAdded = ref({});
		const loadingOrder = ref(false);
		const runSearch = ref(false);
		const filterWasChanged = ref(false);
		const transparent = ref(false);
		const showSearchToolTip = ref(false);
		const filter = ref({
			name: '',
			projects: [],
			allProjects: false
		});

		const projectList = computed(() => store.state.general.projectList);
		const projectListLoaded = computed(() => store.state.general.projectListLoaded);

		const filterInfo = computed(() => {
			return props.meta.filterInfo || null;
		});

		const filterId = computed(() => {
			return (props.meta.filterInfo && props.meta.filterInfo._id) ? props.meta.filterInfo._id : null;
		});

		const projects = computed(() => {
			let projects = [];
			projectList.value.forEach(function (p) {
				if (!p.shared) projects.push({ _id: p._id, label: p.name });
			});
			return projects;
		});

		const showSaveFilterCompd = computed(() => {
			return props.showSaveFilter && searchQuery.value.count > 0;
		});

		const hiddenByDefaultCompd = computed(() => {
			if (typeof props.hiddenByDefault === 'string') {
				return props.hiddenByDefault.toLowerCase() === 'all' ? Object.keys(props.searchSetup) : [];
			}
			return props.hiddenByDefault;
		});

		const hasOrderBy = computed(() => {
			return props.orderByList.length > 0;
		});
		
		const allInputInstances = computed(() => {
			let instances = [];
			searched.value.forEach((inputs, searchIndex) => {
				instances[searchIndex] = {};
				if (inputs) {
					Object.keys(inputs).forEach((inputName) => {
						instances[searchIndex][inputName] = [inputName];
						if (inputInstances.value[searchIndex] && inputInstances.value[searchIndex][inputName]) {
							inputInstances.value[searchIndex][inputName].forEach((i) => {
								instances[searchIndex][inputName].push(inputName + '____' + i);
							});
						}
					});
				}
			});
			return instances;
		});

		const searchQuery = computed(() => {
			let all = [], 
				count = 0;

			searched.value.forEach(function (search, searchIndex) {
				let queries = [];

				searchInputs.value.forEach(function (searchGroup) {
					searchGroup.filters.forEach(function (searchInput) {
						if (!allInputInstances.value[searchIndex] || !allInputInstances.value[searchIndex][searchInput.var]) return;

						allInputInstances.value[searchIndex][searchInput.var].forEach(function (instanceName) {
							let query = {
								label: labelText(searchInput),
								options: []
							}, types;

							switch (searchInput.type) {
								case 'text':
								case 'number':
								case 'select':
									if (searched.value[searchIndex][instanceName] !== '' && searched.value[searchIndex][instanceName] !== null) {
										let v = searched.value[searchIndex][instanceName];
										if (searchInput.type === 'select') {
											let ops = typeof searchInput.options === 'string' ? props.selectOptions[searchInput.options] : searchInput.options;
											if (ops) {
												const foundOption = ops.find(op => op._id === v);
												if (foundOption) v = foundOption.label;
											}
										}
										if (!v) break;
										let values = [v];
										if (props.searchSetup[instanceName.split('____')[0]].multiSplitter) {
											values = v.toString().split(props.searchSetup[instanceName.split('____')[0]].multiSplitter);
										}
										query.options.push({ comparison: getComparisonLabel(searchIndex, instanceName), values: values });
										++count;
									}
									break;
								case 'number-from-to':
								case 'date-range':
									types = searchInput.type === 'number-from-to' ? ['from', 'to', 'at least', 'more than'] : ['start', 'end', 'no earlier than', 'later than'];
									[0, 1].forEach(function (i) {
										if ( 
											searched.value[searchIndex][instanceName] &&
											searched.value[searchIndex][instanceName][types[i]] &&
											searched.value[searchIndex][instanceName][types[i]] !== '' &&
											searched.value[searchIndex][instanceName][types[i]] !== null
										) {
											let v = searched.value[searchIndex][instanceName][types[i]],
												comparison;
											if (searchInput.type === 'date-range') {
												v = general.dateFormat('jS M Y', v);
											}
											if (i === 0) {
												comparison = 'is ' + types[2];
											} else if (query.options.length > 0) {
												comparison = 'no ' + types[i + 1];
											} else {
												comparison = 'is no ' + types[i + 1];
											}
											if (v === '' || v === null) return;
											++count;
											query.options.push({ comparison: comparison, values: [v] });
										}
									});
									break;
							}
							if (Object.keys(query.options).length > 0) queries.push(query);
						});
					});
				});
				if (queries.length > 0) all.push(queries);
			});

			if (all.length === 0) {
				all = [[{ label: "You have no filters selected at the moment", empty: true }]];
			}
			return { query: all, count: count };
		});

		const showClearAll = computed(() => {
			if (searched.value.length > 1) return true;
			if (searched.value.length === 0) return false;
			let show = false;
			Object.keys(searched.value[0]).forEach(function (s) {
				if (searched.value[0][s]) show = true;
			});
			return show;
		});

		const searchInputs = computed(() => {
			let setup = { g: [] };
			Object.keys(props.groupSetup).forEach(function (k) {
				setup[k] = [];
			});
			Object.keys(props.searchSetup).forEach(function (k) {
				let item = props.searchSetup[k];
				if (item.hide) return;
				item.var = k;
				let group = (item.group && props.groupSetup[item.group]) ? item.group : 'g';
				if (!item.comparisons || item.comparisons.length === 0) {
					item.comparisons = item.comparison ? [item.comparison] : [];
				}
				setup[group].push(item);
			});
			let processed = [];
			Object.keys(setup).forEach(function (group) {
				if (setup[group].length === 0) return;
				let isOpen = group === 'g' ? true : !!props.groupSetup[group].open;
				processed.push({ 
					filters: setup[group],
					groupName: group === 'g' ? null : group, 
					label: group === 'g' ? '' : props.groupSetup[group].label,
					open: isOpen
				});
			});
			return processed;
		});

		const hideTip = () => {
			TokenService.saveHide(props.name + 'SearchDescription', true);
			showSearchToolTip.value = true;
		};

		const saveFilter = () => {
			if (filter.value.name === '') {
				general.$snotify(vm, 'error', 'Save Filter', "Please enter a filter name.");
			} else {
				let info = close(true);
				info.filterInfo = general.stripObject(filter.value);
				emit('saveFilter', info);
			}
		};

		const _filterChanged = () => {
			filterWasChanged.value = true;
			emit('changed');
		};

		const totalVisibleFieldsInGroup = (searchIndex) => {
			let c = 0;
			if (allInputInstances.value[searchIndex]) {
				Object.keys(allInputInstances.value[searchIndex]).forEach((inputName) => {
					if (showField(searchIndex, inputName)) c++;
				});
			}
			return c;
		};

		const showField = (searchIndex, searchInputVar) => {
			return !(hidden.value[searchIndex] && hidden.value[searchIndex].indexOf(searchInputVar) >= 0);
		};

		const hiddenFieldsDropdown = (searchIndex, groupIndex) => {
			let fields = [];
			if (hiddenByDefaultCompd.value.length > 0) {
				if (hidden.value[searchIndex] && hidden.value[searchIndex].length > 0) {
					hidden.value[searchIndex].forEach((h) => {
						fields.push({ label: props.searchSetup[h].showLabel, value: h, searchIndex: searchIndex });
					});
				}
				searchInputs.value[groupIndex].filters.forEach((f) => {
					if (f.duplicate) {
						const found = fields.find(a => a.value === f.var);
						if (!found) {
							fields.push({ label: f.showLabel, value: f.var, searchIndex: searchIndex });
						}
					}
				});
				fields.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
			}
			return fields.length > 0 ? fields : null;
		};

		const duplicate = (searchInput, searchIndex, val) => {
			let s = general.stripObject(searched.value[searchIndex][searchInput.var]);
			let i = 2;
			if (val) {
				s = val;
			} else {
				if (s && typeof s === 'object') {
					Object.keys(s).forEach(n => s[n] = null);
				} else {
					s = null;
				}
			}

			if (!inputInstances.value[searchIndex]) {
				inputInstances.value[searchIndex] = {};
			}
			if (!inputInstances.value[searchIndex][searchInput.var] || inputInstances.value[searchIndex][searchInput.var].length === 0) {
				inputInstances.value[searchIndex][searchInput.var] = [];
			} else {
				i = Math.max(...inputInstances.value[searchIndex][searchInput.var]) + 1;
			}
			
			const newInstances = [...(inputInstances.value[searchIndex][searchInput.var] || []), i];
			inputInstances.value = {...inputInstances.value, [searchIndex]: {...inputInstances.value[searchIndex], [searchInput.var]: newInstances}};

			const newSearched = {...searched.value[searchIndex], [searchInput.var + '____' + i]: s};
			searched.value = [...searched.value.slice(0, searchIndex), newSearched, ...searched.value.slice(searchIndex + 1)];
			
			lastAdded.value = {...lastAdded.value, [searchIndex]: searchInput.var + '____' + i};
		};

		const deleteField = (searchInput, searchIndex, instanceIndex, instanceName) => {
			if (lastAdded.value[searchIndex] && lastAdded.value[searchIndex] === searchInput.var) {
				lastAdded.value[searchIndex] = null;
			}
			if (instanceIndex === 0) {
				hidden.value[searchIndex].push(searchInput.var);
				searched.value[searchIndex][searchInput.var] = resetSearchField(searchInput.var);
				return;
			}
			let instances = [...inputInstances.value[searchIndex][searchInput.var]];
			instances.splice(instanceIndex - 1, 1);
			inputInstances.value[searchIndex][searchInput.var] = instances;
			delete searched.value[searchIndex][instanceName];
			searched.value = [...searched.value]; // trigger reactivity
		};

		const labelText = (searchInput) => {
			return searchInput.showLabel ? searchInput.showLabel : searchInput.placeholder;
		};

		const close = (returnOnly, doRunSearch) => {
			let processed = [];
			if (typeof doRunSearch !== 'undefined') runSearch.value = doRunSearch;

			searched.value.forEach((searchGroup, searchGroupIndex) => {
				let withVals = {};
				Object.keys(searchGroup).forEach((fieldName) => {
					let info = searchGroup[fieldName];
					if (info === null) return;
					if (typeof info === 'object') {
						let vals = {};
						Object.keys(info).forEach((filterType) => {
							let val = info[filterType];
							if ((typeof val === 'string' && val !== '') || typeof val === 'number') {
								vals[filterType] = val;
							}
						});
						if (Object.keys(vals).length > 0) {
							withVals[fieldName] = vals;
						}
					} else if ((typeof info === 'string' && info !== '') || typeof info === 'number') {
						withVals[fieldName] = { 
							value: info, 
							comparison: Object.keys(props.comparisonLabels)[comparisonSelected.value[searchGroupIndex][fieldName]]
						};
					}
				});
				if (Object.keys(withVals).length > 0) {
					processed.push(withVals);
				}
			});

			processed = {
				query: processed,
				orderBy: hasOrderBy.value ? orderBySelected.value : [],
				filterWasChanged: filterWasChanged.value
			};

			const rtn = { 
				processed: processed, 
				searchQuery: searchQuery.value.query,
				orderBySelected: orderBySelected.value,
				_id: filterId.value,
				runSearch: runSearch.value
			};
			
			if (returnOnly) return rtn;
			
			emit('close', rtn);
		};

		const getComparisonLabel = (searchIndex, searchInput) => {
			if (!comparisonSelected.value[searchIndex]) {
				comparisonSelected.value[searchIndex] = {};
			}
			let allowed = comparisonIndexesAllowed(searchInput);
			if (typeof comparisonSelected.value[searchIndex][searchInput] === 'undefined') {
				comparisonSelected.value[searchIndex][searchInput] = allowed[0];
			}
			let index = comparisonSelected.value[searchIndex][searchInput];
			let key = Object.keys(props.comparisonLabels)[index];
			return props.comparisonLabels[key];
		};

		const comparisonIndexesAllowed = (searchInput) => {
			let comparisons = props.searchSetup[searchInput.split('____')[0]].comparisons;
			let allowed = [];
			Object.keys(props.comparisonLabels).forEach((type, i) => {
				if (comparisons.indexOf(type) >= 0) {
					allowed.push(i);
				}
			});
			return allowed;
		};

		const changeComparison = (searchIndex, searchInput) => {
			let allowed = comparisonIndexesAllowed(searchInput);
			let index = comparisonSelected.value[searchIndex][searchInput] || allowed[0];
			let found = allowed.indexOf(index);
			index = ((found + 1) >= allowed.length) ? allowed[0] : allowed[found + 1];
			comparisonSelected.value[searchIndex][searchInput] = index;
			comparisonSelected.value = {...comparisonSelected.value}; // trigger reactivity
		};

		const toggleGroup = (searchIndex, groupName) => {
			if (!open.value[searchIndex]) {
				open.value[searchIndex] = {};
			}
			open.value[searchIndex][groupName] = !open.value[searchIndex][groupName];
			open.value = {...open.value}; // trigger reactivity
		};
		
		const clearAll = () => {
			searched.value = [];
			comparisonSelected.value = [{}];
			hidden.value = [];
			addField.value = {};
			lastAdded.value = {};
			_filterChanged();
			addSearch();
			runSearch.value = true;
			orderBySelected.value = [];
		};

		const removeSearchLine = (searchIndex) => {
			if (comparisonSelected.value[searchIndex]) delete comparisonSelected.value[searchIndex];
			searched.value.splice(searchIndex, 1);
			hidden.value.splice(searchIndex, 1);
			if (lastAdded.value[searchIndex]) lastAdded.value[searchIndex] = null;
			if (addField.value[searchIndex]) addField.value[searchIndex] = null;
			_filterChanged();
		};

		const removeOrderByLine = (orderByIndex) => {
			orderBySelected.value.splice(orderByIndex, 1);
		};

		const addOrderBy = () => {
			if (!hasOrderBy.value) return;
			let v = {
				field: props.orderByDefault || null,
				direction: props.orderByDefaultDirection || null
			};
			orderBySelected.value.push(v);
		};

		const resetSearchField = (fieldVar) => {
			let f = props.searchSetup[fieldVar],
				v = null;
			if (f.type === 'number-from-to') {
				v = { from: '', to: '' };
			}
			if (typeof f.default !== 'undefined') v = f.default;
			return v;
		};

		const addSearch = (new1) => {
			let i = searched.value.length;
			let searchItem = (new1 && props.values.query[i]) ? props.values.query[i] : {};
			let h;
			if (tfModalScrollWrap.value) {
				h = tfModalScrollWrap.value.offsetHeight - 80;
			}

			let newSearchedItem = {};
			Object.keys(props.searchSetup).forEach((k) => {
				newSearchedItem[k] = searchItem[k] || resetSearchField(k);
				if (props.searchSetup[k].group) {
					if (!open.value[i]) open.value[i] = {};
					open.value[i][props.searchSetup[k].group] = !!props.groupSetup[props.searchSetup[k].group].open;
				}
				let newComparisonSelected = comparisonSelected.value[i] || {};
				if (searchItem[k] && searchItem[k].value) {
					newComparisonSelected[k] = 0;
					if (searchItem[k].comparison) {
						let compIndex = Object.keys(props.comparisonLabels).indexOf(searchItem[k].comparison);
						newComparisonSelected[k] = compIndex < 0 ? 0 : compIndex;
					}
					newSearchedItem[k] = searchItem[k].value;
				}
				comparisonSelected.value[i] = newComparisonSelected;
			});
			searched.value.push(newSearchedItem);

			let thisHidden = [];
			hiddenByDefaultCompd.value.forEach(function (h) {
				let show = false;
				if (new1 && props.values.query[i]) {
					if (props.values.query[i][h]) {
						if (typeof props.values.query[i][h] === 'object') {
							Object.keys(props.values.query[i][h]).forEach(function (n) {
								if (props.values.query[i][h][n]) show = true;
							});
						} else {
							show = true;
						}
					}
				}
				if (!show) thisHidden.push(h);
			});
			hidden.value.push(thisHidden);

			Object.keys(props.searchSetup).forEach((k) => {
				let ii = 2;
				while (props.values.query && props.values.query[i] && props.values.query[i][k + '____' + ii]) {
					if (typeof props.values.query[i][k + '____' + ii].comparison !== 'undefined') {
						comparisonSelected.value[i][k + '____' + ii] = Object.keys(props.comparisonLabels).indexOf(props.values.query[i][k + '____' + ii].comparison);
					}
					duplicate(props.searchSetup[k], i, props.values.query[i][k + '____' + ii].value);
					++ii;
				}
			});

			if (h && tfModalScroll.value) {
				setTimeout(() => {
					tfModalScroll.value.scrollTop = h;
				}, 100);
			}
		};

		const changeDate = (searchInputVar, index, info) => {
			searched.value[index][searchInputVar] = info;
			_filterChanged();
		};

		watch(addField, (newValue) => {
			Object.keys(newValue).forEach((searchIndex) => {
				let v = newValue[searchIndex];
				if (v && hidden.value[searchIndex]) {
					let index = hidden.value[searchIndex].indexOf(v.value);
					if (index >= 0) {
						hidden.value[v.searchIndex].splice(index, 1);
						lastAdded.value[v.searchIndex] = v.value;
					} else {
						duplicate({ var: v.value }, v.searchIndex);
					}
					addField.value[v.searchIndex] = null;
				}
			});
		}, { deep: true });

		watch(orderBySelected, () => {
			if (loadingOrder.value) {
				loadingOrder.value = false;
				return;
			}	
			_filterChanged();
		}, { deep: true });

		watch(searched, () => {
			Object.keys(lastAdded.value).forEach((index) => {
				if (searched.value[index] && searched.value[index][lastAdded.value[index]]) {
					lastAdded.value[index] = null;
					_filterChanged();
				}
			});
		}, { deep: true });

		// Created logic
		runSearch.value = false;
		if (props.name) {
			showSearchToolTip.value = !!props.toolTipText && !!TokenService.getHide(props.name + 'SearchDescription');
		}

		if (props.values.query && props.values.query.length > 0) {
			props.values.query.forEach(() => {
				addSearch(true);
			});
		} else {
			addSearch();
		}

		loadingOrder.value = true;
		orderBySelected.value = props.values.orderBy ? general.stripObject(props.values.orderBy) : [];
		let validOrderBy = [];
		orderBySelected.value.forEach((o) => {
			if (o && typeof o.field !== 'undefined' && typeof o.direction !== 'undefined') {
				validOrderBy.push(o);
			}
		});
		orderBySelected.value = validOrderBy;

		if (filterInfo.value && filterInfo.value._id) {
			filter.value.projects = filterInfo.value.projects || [];
			filter.value.allProjects = !!filterInfo.value.allProjects;
			filter.value.name = filterInfo.value.name || '';
		} else if (props.meta.project) {
			filter.value.projects.push(props.meta.project);
		}

		transparent.value = false;
		let ins = !!props.meta.filterInfo && !!props.meta.filterInfo.instantClose;
		if (props.initialLoad || !!ins) {
			transparent.value = !!ins;
			setTimeout(() => {
				close(false, true);
			}, ins ? 10 : 100);
		}

		return {
			tfModalScroll,
			tfModalScrollWrap,
			searched,
			overflowVisible,
			open,
			comparisonSelected,
			inputInstances,
			orderBySelected,
			hidden,
			addField,
			lastAdded,
			loadingOrder,
			runSearch,
			filterWasChanged,
			transparent,
			showSearchToolTip,
			filter,
			projectList,
			projectListLoaded,
			filterInfo,
			filterId,
			projects,
			showSaveFilterCompd,
			hiddenByDefaultCompd,
			hasOrderBy,
			searchQuery,
			allInputInstances,
			showClearAll,
			searchInputs,
			hideTip,
			saveFilter,
			filterChanged: _filterChanged,
			totalVisibleFieldsInGroup,
			showField,
			hiddenFieldsDropdown,
			duplicate,
			deleteField,
			labelText,
			close,
			getComparisonLabel,
			comparisonIndexesAllowed,
			changeComparison,
			toggleGroup,
			clearAll,
			removeSearchLine,
			removeOrderByLine,
			addOrderBy,
			resetSearchField,
			addSearch,
			changeDate,
		};
	}
}
</script>
<style lang="less" scoped>
@import './../assets/css/less/_helper.less';
@import './../assets/css/less/_settings.less';
@media all {

	@keyframes pulse {
		0% {
			background-color: @darkContrast;
			color: #fff;
		}

		100% {
			color: @darkContrast;
			background-color: #fff;
		}
	}

	.modal {

		&.transparent {
			.opacity(0);
		}

		&.initial-load {

			opacity: 0;
			pointer-events: none;

		}

		.modal-inner {

			max-width: 1000px;

			.tool-tip {

				text-align: right;
				position: absolute;
				right: 20px;
				top: -16px;

			}
			
			.modal-title {

				border-radius: 8px 8px 0 0;

			}

		}

		.modal-inner-scroll {

			max-width: none;

		}

		&.vis-overflow {

			.modal-inner, .modal-inner-scroll {

				overflow: visible;

			}

		}

	}

	.projects {

		padding-top: 20px;

		p {
			padding: 0;
			margin: 0 0 10px;
		}

	}

	.opener {

		margin: 0 0 10px;

		.hide {

			opacity: 0.5;
			font-style: italic;
			cursor: pointer;

			&:hover {
				opacity: 1;
				text-decoration: underline;
			}

		}

	}

	.remove {

		.opacity(0.8);
		position: absolute;
		cursor: pointer;
		top: 50%;
		margin-top: -8px;
		left: 0;
		
		&:hover {

			.opacity(1);

		}

	}

	.footer {

		.filter-name-wrap {

			display: inline-block;

		}

	}

	.order-by {

		margin-top: 30px;

		.main-title {

			margin-bottom: 5px;

		}

		.order-by-line {

			position: relative;
			margin-bottom: 10px;
			padding-left: 26px;

			.v-select {

				margin-bottom: 0;

				&.direction {

					width: 170px;

				}

			}

			&.multi {

				padding-left: 25px;

			}

		}

		.add-search {

			margin-top: 0;

		}

	}

	.large-button {

		margin-right: 5px;
		margin-bottom: 10px;

		&.search {

			display: none;

		}

		&.clear {

			.opacity(0.65);

		}

		&.save {

			

		}

	}

	.fields-dropdown {

		margin-top: 5px;

	}

	.search-line {

		position: relative;
		margin: 20px 0px 0 0;
		padding-top: 0;

		svg {

			left: -8px;

		}

		&.multi {

			padding: 10px 10px 10px 25px;
			border: 1px solid rgba(200,200,200,0.8);
			border-radius: 5px;

		}

		.group-title {

			margin-top: 10px;
			cursor: pointer;

			&:after {

				content: "Show";
				font-size:0.5em;
				display: inline-block;
				vertical-align: middle;
				padding-left: 10px;
				.opacity(0.5);
				.trans;

			}

			&:hover {

				&:after {

					.opacity(1);

				}

			}

			&.open {

				&:after {

					content: "Hide";

				}

			}

		}

		&:after {

			content: "or";
			position: absolute;
			width: auto;
			color: #fff;
			left: 50%;
			top: -24px;
			text-align: center;
			background-color: @darkContrast;
			.rounded(50%);
			width: 26px;
			padding: 2px 0;
			margin-left: -13px;

		}

		&:first-child {

			&:after, &:before {

				display: none;

			}

		}

	}

	.add-search {

		.opacity(0.8);
		cursor: pointer;
		margin-top: 30px;
		display: inline-block;

		svg {
			margin-right: 5px;
		}

		&:hover {

			.opacity(1);

		}

	}

	.search-title {
		line-height: 1em;
		margin-top: 12px;
		font-size: 16px;
	}

	.input-wrap {

		width: 100%;
		display: inline-block;
		margin:10px 10px 0 0;
		position:relative;
		vertical-align: top;

		&.last-added {

			&:after {

				content: "New";
				position: absolute;
				top: 0;
				right: 0;
				font-size: 10px;
				padding: 2px 4px;
				background-color: @darkContrast;
				color: #fff;
				.rounded(5px);
				animation: pulse 2s 2;

			}

		}

		.number-from-to {

			line-height: 2em;

		}

		&.number {

			width: 100px;

		}

		&.button, &.switcher {

			width: auto;

		}

		label {

			display: block;
			font-size:12px;
			margin-bottom: 2px;
			margin-right: 30px;

			.duplicate, .delete {

				display: inline-block;
				font-size: 10px;
				padding: 4px 6px 3px;
				display: inline-block;
				position: relative;
				background-color: @darkContrast;
				color: #fff;
				line-height: 1em;
				.rounded(50%);
				cursor: pointer;
				vertical-align: top;

				&:hover {

					background-color: @formDefaultColour;

				}

			}

			.delete {

				padding: 3px 6px 4px;

			}

		}

		.large-button {

			padding: 5px 8px;
			font-size: 14px;
			margin-top: 2px;

		}

	}

	input {

		outline: none;
		font-size: 14px;
		border-radius: 3px;

		&[type=text],&[type=number] {

			border: 1px solid rgba(0, 0, 0, 0.1);
			padding: 5px;
			height: 34px;
			vertical-align: top;
			width: 100%;
			display: inline-block;

		}

		&[type=number] {

			width: 80px;

		}

	}

	.input-text-wrap {

		position: relative;
		border: 1px solid rgba(0, 0, 0, 0.1);
		background-color: #F8FAFB;
		.rounded(5px);

		.comparison {

			background-color: @darkContrast;
			display: inline-block;
			color: #fff;
			line-height: 0.8em;
			padding: 4px;
			.rounded(5px);
			margin: 0 2px 0 5px;
			font-size: 12px;
			vertical-align: middle;
			vertical-align: -webkit-baseline-middle;
			-webkit-touch-callout: none; /* iOS Safari */
			-webkit-user-select: none; /* Safari */
			-khtml-user-select: none; /* Konqueror HTML */
			-moz-user-select: none; /* Old versions of Firefox */
				-ms-user-select: none; /* Internet Explorer/Edge */
					user-select: none; 

			&.multi {

				cursor: pointer;

				&:hover {

					background-color: @formDefaultColour;

				}

			}

		}

		input {

			&[type=text], &[type=number] {

				border: none;
				background: none;
				display: inline-block;
				width: auto;
				margin: 0;
				-webkit-font-smoothing: antialiased;
				-moz-osx-font-smoothing: grayscale;

			}

		}

	}

	.search-actions {

		margin-top: 0;
		display: inline-block;
		vertical-align: bottom;

	}

	.mag {

		width: 20px;
		height: 20px;
		.opacity(0.5);
		cursor: pointer;
		display: inline-block;
		margin-right: 10px;

		&:hover {
			.opacity(1);
		}

	}

	.v-select {

		display: inline-block;
		width: 100%;
		vertical-align: top;
		font-family: inherit;
		font-size: 16px;
		font-weight: 400;
		border: 1px solid rgba(0, 0, 0, 0.1);

		&.no-margin {

			margin-bottom: 0;

		}

		.vs__search {

			font-family: inherit;
			font-size: 14px;
			margin: 6px 0 0;
			color: rgba(0,0,0,0.55);

		}

		.vs__dropdown-toggle, .vs__dropdown-menu {

			border-color:rgba(0,0,0,0.1);
			border-radius: 0;

		}

		.vs__dropdown-toggle {

			padding: 0 0 5px;

		}

	}
}
@media all and (min-width: 768px) {
	
	.input-wrap {

		width: auto;
		margin-right: 20px;

		&.dates, &.number {

			width: auto;

		}

		&.dates {

			width: 210px;

		}

	}

	.v-select {

		width: 250px;

	}

}
@media screen and (min-width: 1024px) and (min-height: 600px) {

	.modal {

		.modal-inner-scroll {

			max-height: calc(80vh - 100px);

		}

	}

	.large-button {

		&.search {

			position: fixed;
			right: 100px;
			bottom: 15px;
			background-color: #fff;
			color: @darkContrast;
			padding: 5px 8px;
			margin: 0;
			display: block;

			&:hover {

				color: #fff;
				background-color: @darkContrast;

			}

		}

	}
	
}
</style>